// React / Zustand
import { create } from 'zustand';

// Store
import useProfileStore from './profileStore.js';

// Services
import { getAthlete } from '../service/httpService/athlete/index.js';
import { getCoachesOfAthlete } from '../service/httpService/coach/index.js';
import { getParentsOfAthlete } from '../service/httpService/parent/index.js';
import { getWeeklyScheduleOfAthlete } from '../service/httpService/weeklySchedule/index.js';
import { getAllFeedbacksOfWeekOfAthlete } from '../service/httpService/feedback/index.js';

const useAthleteStore = create((set, get) => ({

    // BASIC USER DATA
    hasExtendedFeedback: null,
    squad: null,
    status: null,
    coaches: null,
    parents: null,

    // WEEKLY SCHEDULE + FEEDBACK
    weeklySchedule: null,
    feedbacks: [],

    // ⭐ TRAININGSESSIONS — IMMER EIN ARRAY!
    trainingSessions: [],

    // ⭐ Sicheres Setzen → niemals undefined, null oder Objekt
    setTrainingSessions: (sessions) => {
        set({
            trainingSessions: Array.isArray(sessions) ? sessions : []
        });
    },

    // ⭐ Sicheres Entfernen
    removeTrainingSession: () => {
        const current = get().trainingSessions;
        if (!Array.isArray(current)) return;

        const values = [...current];
        if (values.length > 0) values.pop();

        set({ trainingSessions: values });
    },

    // --------------------------------------------------------
    //                    ATHLETE FUNCTIONS
    // --------------------------------------------------------

    getAthleteData: async () => {
        const { userEmail } = useProfileStore.getState();
        const resAthlete = await getAthlete(userEmail).catch(() => false);

        if (!resAthlete) return false;

        set({
            hasExtendedFeedback: resAthlete.data.hasExtendedFeedback,
            squad: resAthlete.data.squad,
            status: resAthlete.data.status
        });

        return true;
    },

    getCoaches: async () => {
        const { userEmail } = useProfileStore.getState();
        const resCoaches = await getCoachesOfAthlete(userEmail).catch(() => false);

        if (!resCoaches) return false;

        set({ coaches: resCoaches.data });
        return true;
    },

    getParents: async () => {
        const { userEmail } = useProfileStore.getState();
        const resParents = await getParentsOfAthlete(userEmail).catch(() => false);

        if (!resParents) return false;

        set({ parents: resParents.data });
        return true;
    },

    // --------------------------------------------------------
    //                  GET WEEKLY SCHEDULE
    // --------------------------------------------------------

    getWeeklySchedule: async (year, selectedCalenderWeek) => {
        const { userEmail } = useProfileStore.getState();

        set({
            weeklySchedule: { data: undefined, loading: true },
            feedbacks: []
        });

        const resWeekly = await getWeeklyScheduleOfAthlete(
            userEmail,
            year,
            selectedCalenderWeek
        ).catch(() => false);

        if (!resWeekly) {
            set({
                weeklySchedule: { data: undefined, loading: false }
            });
            return;
        }

        const schedule = resWeekly.data;

        // ⭐ Falls Backend keine trainingSessions liefert → immer Array
        const trainingSessions = Array.isArray(schedule?.trainingSessions)
            ? schedule.trainingSessions
            : [];

        set({
            weeklySchedule: {
                data: schedule,
                loading: false
            },
            trainingSessions: trainingSessions
        });

        // Feedbacks abrufen
        const resFeedbacks = await getAllFeedbacksOfWeekOfAthlete(
            userEmail,
            year,
            selectedCalenderWeek
        ).catch(() => false);

        if (!resFeedbacks) return;

        set({ feedbacks: resFeedbacks.data });

        return true;
    }

}));

export default useAthleteStore;
